import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ChantierFilterStore {
  // Filtre statut chantier partagé entre Dashboard et Projects
  filterStatus: string;
  setFilterStatus: (status: string) => void;
}

export const useChantierFilterStore = create<ChantierFilterStore>()(
  persist(
    (set) => ({
      filterStatus: 'all',
      setFilterStatus: (status) => set({ filterStatus: status }),
    }),
    {
      name: 'b8ild-chantier-filter',
      partialize: (state) => ({
        filterStatus: state.filterStatus,
      }),
    }
  )
);
